// extracted by mini-css-extract-plugin
export default {"productFeatured":"kda-z","carousel":"lda-z","slides":"mda-z","slide":"nda-z","slideFeatured":"oda-z","zoomMode":"pda-z","fadeIn":"qda-z","imageSizing":"rda-z"};